import React from 'react'
import List from './List'
import { useCandidateContractualDocumentById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const candidate = useCandidateContractualDocumentById(id)
  return (
    <List candidate={candidate} />
  )
}

export default Body
